import { combineReducers } from "@reduxjs/toolkit";
import {
  addBalanceReducer,
  getAllEarningReducer,
  getAllStatementsReducer,
  getBalanceReducer,
} from "./slices";

const balanceReducer = combineReducers({
  balance: getBalanceReducer,
  addBalance: addBalanceReducer,
  allEarning: getAllEarningReducer,
  allStatements: getAllStatementsReducer,
});

export default balanceReducer;
